import Link from "next/link";
import { forwardRef } from "react";

/*
  <a 
    variant={variant}
    color={color}
    size={size} 
    className={className}
    href={href}
  />
  - - - - - - - - - - - - -
  variant -> primary / ghost
  color -> white / black
  size -> lg / sm
  className -> css classes
  href -> page links
  - - - - - - - - - - - - -
*/

const Button = forwardRef(
  ({ variant, color, className, size, href, children, ...props }, ref) => {
    return (
      <a
        href={href}
        className={`btn btn--${variant} btn--${size} tc-${color} ${className}`}
        ref={ref}
        {...props}
      >
        {children}
      </a>
    );
  }
);

Button.defaultProps = {
  variant: "primary",
  color: "white",
  size: "sm",
  className: "",
  href: "#",
};

export default Button;
